const language = {
    'pt': 
        {
            abstract: 'Resumo',
            accepted_languages : 'Línguas aceites?' ,
            accepted:    'Aceite',
            accepted_change:    'Aceite sujeito a alterações',
            access_data:        'Dados de acesso',
            add :       'Adicionar' ,
            add_author:       'Adicionar autor' ,
            add_cfp :       'Adicionar CFP' ,
            add_files:      'Adicionar ficheiro(s)',
            add_files_placeholder : 'Clique aqui para seleccionar os seus ficheiros' ,
            add_guest:      'Adicionar Convidado' ,
            add_new :       'Adicionar Novo' ,
            add_new_appreciation:   'Adicionar uma nova apreciação',
            add_new_appreciation_info_message:   'Para que a sua apreciação seja gravada clique no botão "submeter" e de seguida em "guardar".',
            add_new_cfp :       'Adicionar nova Call for papers' ,
            add_new_cfp_article_edit_deadline: 'Data limite de edição de artigo' ,
            add_new_cfp_article_edit_deadline_placeholder: 'Introduza a data limite de edição de artigo' ,
            add_new_cfp_description_placeholder: 'Introduza a descrição da CFP' ,
            add_new_cfp_end_date: 'Data limite de fim' ,
            add_new_cfp_end_date_placeholder : 'Introduza a data limite de fim' ,
            add_new_cfp_name_placeholder: 'Introduza o nome da CFP' ,
            add_new_cfp_process_end_date : 'Data de final do processo' ,
            add_new_cfp_process_end_date_placeholder : 'Introduza a data de final do processo' ,
            add_new_cfp_rev_fin_dec_date : 'Data da decisão final do revisor' ,
            add_new_cfp_rev_fin_dec_date_placeholder : 'Introduza a data da decisão final do revisor' ,
            
            add_new_cfp_rev_resp_date : 'Data de resposta de revisão' ,
            add_new_cfp_rev_resp_date_placeholder : 'Introduza a data de resposta de revisão' ,
            add_new_cfp_start_date: 'Data de início' ,
            add_new_cfp_start_date_placeholder : 'Introduza a data de início' ,
            add_new_cfp_submission_date: 'Data de submissão' ,
            add_new_cfp_submission_date_placeholder : 'Introduza a data de submissão' ,
            add_new_cfp_sup_mat_deliv_date : 'Data de entrega de material suplementar' ,
            add_new_cfp_sup_mat_deliv_date_placeholder : 'Introduza data de entrega de material suplementar' ,
            add_new_cfp_text :  'Para que a sua Call for papers seja gravada clique no botão "Adicionar Cfp" e de seguida em "salvar".' ,
            add_new_sientific_diffusion_text :  'Escolha a call for papers e em seguida selecione os artigos do mesmo para adicionar na difusão.' ,
            add_publisher : 'Adicionar Editor' ,
            add_question : 'Adicionar pergunta' ,
            add_reviewer:       'Adicionar revisor',
            add_select_articles :  'Adicionar artigo(s) seleccionados' ,
            add_select_articles_error_message :  'Não seleccionou nenhum artigo!' ,
            add_select_articles_sucess_message :  'Artigo(s) adicionado(s) com sucesso.' ,
            add_topic : 'Adicionar Tópico' ,
            add_topic_error:    'Problema ao atualizar registo!',
            admin:              'Administrador',
            adress:             'Morada', 
            affiliation:        'Organização',
            affiliation_insert: 'Introduza a organização',
            appreciations:      'Apreciações',
            article:            'Artigo',
            article_appreciation:   'Apreciação de artigo',
            article_appreciation_view:   'Consultar apreciação do artigo',
            article_final_appreciation: 'Apreciação final do artigo',
            article_code:       'Código do artigo',
            article_edit_deadline: 'Data limite de edição de artigo' ,
            article_status:      'Estado do artigo',
            article_final_status:   'Estado final do artigo',
            article_submission: 'Submissão de artigo',
            article_submission_limit_message_1: 'Apenas pode submeter',
            article_submission_limit_message_2: 'artigo(s) para esta Call For Papper.',
            article_submission_email_message_1: 'Serve o presente email para o/a notificar que o(a) autor(a) ',
            article_submission_email_message_2: ' submeteu o artigo ',
            article_submission_email_message_3: ' na seguinte data: ',
            article_submission_email_message_4: ' pelas ',
            article_resubmission_email_message_1: 'Serve o presente email para o/a notificar que na sequência da respectiva apreciação o(a) autor(a) ',
            article_resubmission_email_message_2: ' submeteu novamente o artigo ',
            article_resubmission_email_message_3: ' na seguinte data: ',
            article_resubmission_email_message_4: ' pelas ',
            article_review:     'Revisão de artigos',
            articles:           'Artigos',
            articles_approved:      'Total de artigos aprovados',
            articles_assigned:      'Total de artigos atribuídos',
            articles_for_review:      'Total de artigos por rever',
            articles_list:      'Lista de artigos',
            articles_list_view:      'Consultar Lista de Artigos',
            articles_publication_error_message:      'Problema ao atualizar registo do artigo!',
            articles_publication_sucess_message :    'Artigos associados à revista atualizados com sucesso' ,
            articles_reviewed:      'Total de artigos revistos',
            articles_submission:'Submissão de artigos',
            articles_submitted: 'Total de artigos submetidos',
            article_title:      'Título do artigo',
            assign_reviewer:    'Atribuir revisor',
            assign_reviewer_confirm_message:    'Tem a certeza que pretende guardar este revisor e enviar a respectiva notificação?',
            assign_reviewers:    'Atribuir revisores',
            assign_reviewers_confirm_message:    'Tem a certeza que pretende guardar este(s) revisores e enviar as respectivas notificações?',
            author :            'Autor' ,
            author_regist:      'Registo de autor',
            authors:            'Autores',
            authors_list:       'Lista de autores',
            author_question_authorization:    'Os autores têm permissão a ver as perguntas e respostas?',
            automatic_method :	'Automático' ,
            available_vacancies:    'Nº de vagas disponíveis',
            back:               'Voltar',
            bibliography:       'Bibliografia',
            biography:          'Biografia',
            cancel:             'Cancelar',
            can_submit_article :    'Pode submeter artigo?' ,
            certificate:        'Certificado',
            certificate_view:   'Ver certificado',
            cfp_delete_confirm_message:      'Tem a certeza que quer apagar esta difusão?',
            cfp_list : 'Lista de Call For Papers' ,
            cfp_name :          'Nome da Call for Papers' ,
            cfp_description:    'Descrição da Call for Papers' ,
            change_password:    'Alterar password',
            change_password_confirm_message:    'Tem a certeza que pretende alterar a sua password?',
            change_password_error_message:    'Problema ao atualizar password!',
            change_password_required_fields_message:    'Tem que preencher todos os campos relativos à alteração de password',
            change_password_sucess_message:    'Password atualizada com sucesso',
            close:              'Fechar',
            code:               'Código',
            confirmation_password_error_message:               'Password de confirmação diferente da password inserida',
            contact_email:      'Email de contacto',
            contact_recovery:   'Formulário de recuperação',  
            contacts:           'Contactos',  
            content:            'Conteúdo',  // TODO: content means happy :)
            contents_plural:    'Conteúdos',
            contents_plural_list:    'Lista de conteúdos',
            content_insert:       'Inserir conteúdo',
            choose_file:        'Escolher arquivo',
            conference :        'Conferência' ,
            country:            'País',
            country_insert:     'Introduza o país',
            courses_available:          'Cursos disponíveis',
            courses_detail:          'Detalhes do curso',
            courses_list:          'Lista de cursos',
            current_password:   'Password atual',
            current_password_error_message:   'A password atual está incorreta',
            date_registration_begin:  'Data de início de inscrição',
            date_registration_deadline:  'Data limite de inscrição',
            data_article:       'Dados do artigo',
            date_placeholder:      'Introduza a data',
            dashboard:           'Painel Principal' ,
            delete:             'Eliminar',
            delete_article_confirm_message:     'Tem a certeza que quer apagar este artigo?',
            delete_cfp:         'Eliminar Call For Papers',
            delete_cfp_cancel:  'Não' ,
            delete_cfp_confirm: 'Sim' ,
            delete_cfp_text:    'Pretende mesmo eliminar este registo?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_entity :     'Eliminar Entidade' ,
            delete_entity_text : 'Tem a certeza que quer apagar esta Entidade?' ,
            delete_error:       'Problema ao apagar registo!',
            delete_event :      'Tem a certeza que quer apagar este Evento?' ,
            delete_image:       'Apagar imagem',
            delete_image_confirm_message:     'Tem a certeza que quer apagar esta imagem?',
            delete_image_error_message:     'Não existe nenhuma imagem',
            delete_profile_image:       'Apagar imagem de perfil',
            delete_profile_image_confirm_message:     'Tem a certeza que quer apagar esta imagem de perfil?',
            delete_profile_image_error_message:     'Não existe nenhuma imagem de perfil',
            delete_record :     'Pretende mesmo eliminar este registo?',
            delete_success:     'Registo apagado com sucesso!',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            description:        'Descrição',
            description_placeholder:      'Introduza a descrição',
            doc_choose:         'Escolher ficheiro',
            duplicate_title:       'Duplicar Registo',
            duplicate_text:        'Tem a certeza que pretende continuar?',
            duplicate_confirm:     'Confirmar',
            duplicate_cancel:      'Cancelar',
            duplicate_error:       'Problema ao duplicar registo!',
            duplicate_no:       'Não',
            duplicate_yes:      'Sim',
            duplicated:         'duplicado',
            duplication_options: 'Opções de duplicação',
            duplication_options_checkbox_01: 'Manter imagem',
            duplication_options_checkbox_02: 'Manter documentos',
            duplication_options_checkbox_03: 'Manter formadores',
            duration:           'Duração (nº de horas)',
            dblpid:             'DBLP ID',
            edit:               'Editar',
            edit_cancel:        'Não',
            edit_confirm:       'Sim',
            edit_error:         'Problema ao atualizar registo!',
            edit_text:          'Tem a certeza que pretende continuar?',
            edition:            'Edição',
            edition_placeholder:      'Introduza a edição',
            editor_regist:      'Registo de editor',
            email:              'E-mail',
            email_contact:      'E-mail preferencial de contacto',   
            email_recover_pass: 'Verifique o seu e-mail.',
            email_recover_pass_2: 'O e-mail não se encontra registado.',
            email_register:     'E-mail',
            email_settings:     'Definições de email',
            end_date:           'Data limite de fim' ,
            english :           'Inglês' ,
            error:              'Erro',
            event :             'Evento' ,
            event_type:         'Tipo de evento',
            events:             'Eventos',
            events_data:        'Dados do Evento' ,
            events_list:        'Lista de eventos',
            failed_login:       'Falha ao iniciar sessão',
            financing:          'Financiamento/custo',
            financing_financed: 'Financiada',
            financing_free:      'Gratuita',
            financing_paid:      'Paga',
            file_types :        'Tipos de ficheiros?' ,
            files:              'Ficheiro(s)',
            formation_language:  'Lingua da formação',
            formation_language_pt:  'Português',
            formation_language_en:  'Inglês',
            formation_language_es:  'Espanhol',
            formation_modality:  'Tipo de Modalidade',
            formation_modality_classroom:  'Presencial',
            formation_modality_online:  'À Distância (online)',
            formation_modality_mixed:  'Misto',
            formation_price:    'Preço',
            formation_registered: 'Inscrito(a)',
            formation_waiting_registered: 'A aguardar aprovação',
            formation_registration: 'Inscrição',
            formation_registration_finish: 'Finalizar inscrição',
            formation_registration_finish_error: 'Problema ao finalizar pedido de inscrição',
            formation_registration_finish_text: 'Vai finalizar o pedido de inscrição no curso ',
            formation_registration_confirm: 'Tem a certeza que pretende inscrever-se neste curso?',
            formation_registration_success: 'Pedido de inscrição efetuado com sucesso.</br> O seu pedido vai ser analisado e será informado(a) da sua resposta brevemente.',
            formation_registration_profile:        'Ir para o perfil',
            formation_registration_rejected: 'Inscrição rejeitada',
            formation_registration_waiting: 'A aguardar resposta',
            formation_registration_warning:        'É necessário o preenchimento de todos os campos obrigatórios do seu perfil para que a inscrição neste curso seja concluída com sucesso!',
            formation_schedule:  'Tipo de Horário',
            formation_schedule_working_hours: 'Laboral',
            formation_schedule_post_work: 'Pós Laboral',
            formation_schedule_flexible: 'Flexivel',
            french :            'Francês' ,
            gest:               'Gestão',
            gscholarid:         'Google Scholar ID',
            guests :            'Convidados' ,
            guest_affiliation : 'Instituição do convidado',
            guest_affiliation_placeholder : 'Introduza a instituição do convidado' ,
            guest_area :        'Área do convidado' ,
            guest_area_placeholder :        'Introduza a área do convidado' ,
            guest_description : 'Descrição do Convidado' ,
            guest_description_placeholder : 'Introduza a descrição do Convidado' ,
            guest_name :        'Nome do convidado' ,
            guest_name_placeholder :        'Introduza o nome do convidado' ,
            hello:               'Olá',
            home:               'Home',
            hours:              'Hora(s)',
            id:                 'ID',
            identifier:         'Introduza o identificador',
            image:              'Imagem',
            image_choose:       'Escolher imagem',
            in_progress:        'Em curso',
            incorrect_login_data: 'Dados de acesso incorretos',
            incorrect_request:  'Pedido incorreto',
            insert_cancel:      'Não',
            insert_cfp_reqs:    'Tem que preencher o campo do título e da descrição do cfp.',
            insert_confirm:     'Sim',
            insert_diffusion:   'Inserir Difusão',
            insert_error:       'Problema ao inserir registo!',
            insert_event :      'Inserir evento' ,
            insert_event_cfp_error_message :      'Não inseriu nenhuma Call for Papper associada a este Evento.' ,
            insert_option:      'Introduza uma opção' ,
            insert_question :   'Introduza a pergunta' ,
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_title:       'Novo Registo',
            insert_url:         'Introduza o URL (endereço)',
            journals_list:      'Lista de revistas',
            keywords:           'Palavras-chave',
            keywords_info:      'Utilize sempre ";" para separar as suas palavras-chave.',
            keywords_insert:    'Introduza as palavras-chave',
            link:               'Link',
            list_publishers:    'Lista de editores',
            list_view:          'Ver lista',
            loading :           'A carregar' ,
            magazine :          'Revista' ,
            magazine_code :     'Código da Revista' ,
            magazine_conference :  'Revista/Conferência' ,
            manual :            'Manual' ,
            materials:          'Materiais',
            max_numb_art_author : 'Número máximo de artigos por autor?' ,
            max_numb_art_author_placeholder : 'Introduza o número máximo de artigos por autor' ,
            max_numb_art_reviewer : "Número máximo de artigos por revisor?" ,
            max_numb_art_reviewer_placeholder: "Introduza o número máximo de artigos por revisor" ,
            max_numb_rev_per_art : 'Número máximo de revisores por artigo?' ,
            max_numb_rev_per_art_placeholder : 'Introduza o número máximo de revisores por artigo' ,
            maximum_submissions_reached: 'máximo de submissões atingido',
            name:               'Nome',
            name_placeholder:   'Introduza o nome',
            new_password:       'Nova password',
            new_password_2:     'Confirmar password',
            new_question :      'Nova pergunta',
            new_question_placeholder : 'Introduza uma pergunta' ,
            new_topic :         'Novo tópico' ,
            no :                'Não' ,
            no_file_selected:   'Nenhum ficheiro selecionado',
            no_results:         'Sem registos',
            notice:             'Aviso',
            notice_message:             'Passados 15 dias da data de conclusão do curso, o formando deixa de ter acesso à gestão e visualização dos conteúdos desse curso.',
            notifications_error_message:             'Problema ao enviar notificações!',
            notifications_sucess_message:             'Notificações enviadas com sucesso',
            notified:           'Notificado',
            notify:             'Notificar',
            notify_author_button:      'Notificar autor',
            notify_appreciation:'Notificar apreciação',
            notify_appreciation_error_message: 'Não selecionou um estado final!',
            notify_all:         'Notificar todos',
            notify_author:      'Serve o presente email para o/a notificar que foi atribuído ao seu artigo',
            notify_author_2:    'o estado final',
            notify_message:     'Tem a certeza que pretende atribuir esta apreciação e notificar o autor do respetivo artigo?',
            objectives:         'Objetivos',
            observations:       'Observações',
            obs_publisher:      'Observações para o editor',
            orcid:              'ORCID',
            password:           'Palavra-passe',
            password_recover:   'Foi registado um pedido de recuperação da palavra-passe da sua conta.',
            password_recover_2: 'Clique no seguinte link para confirmar o seu pedido e escolher outra palavra-passe:',
            password_recover_3: 'Se não efetuou nenhum pedido, ignore este mail e a sua palavra-passe não será alterada.',
            personal_data:      'Dados Pessoais',
            portuguese :        'Português' ,
            proceedings_list:   'Lista de conferências',
            process_end_date :  'Data de final do processo' ,
            profile:            'Perfil',
            profile_image:      'Imagem de perfil',
            publication:        'Publicação',
            publication_confirm_message:      'Tem a certeza que pretende publicar esta revista?',
            publication_error_message:      'Problema ao publicar revista!',
            publication_sucess_message:      'Revista publicada com sucesso',
            publication_date:   'Data de publicação',
            publish:            'Publicar',
            publisher:          'Editor',
            publishers:         'Editores',
            published:          'Publicado',
            published_articles: 'Total de artigos publicados',
            published_journals: 'Revistas publicadas',
            publisher_type:     'Tipo de editor',
            question :          'Pergunta' ,
            questions :         'Perguntas' ,
            recover_password:   'Recuperar palavra-passe',
            register_here:      'Registe-se aqui',
            rejected:           'Rejeitado',
            remove:             'Remover',
            remove_all:         'Remover todos',
            remove_article :    'Remover artigo' ,
            remove_appreciation :    'Remover Apreciação' ,
            remove_author :     'Remover autor' ,
            remove_cfp:         'Este Call for Paper está a decorrer. Não pode ser apagado.',
            remove_file:        'Remover ficheiro',
            remove_publisher :  'Remover editor' ,
            review_type :       'Tipo de Revisão?' ,
            reviewer:           'Revisor',
            reviewer_assignment: 'Atribuição de Revisor',
            reviewer_assignment_email_message_1: 'Serve o presente email para o/a notificar que lhe foi atribuído o artigo ',
            reviewer_assignment_error_message: 'Não adicionou nenhum revisor!',
            reviewer_regist:    'Registo de Revisor',
            reviewers:          'Revisores',
            reviewers_list:     'Lista de revisores',
            registered_authors: 'Autores inscritos',
            registered_reviewers:'Revisores inscritos',
            reviewer_attrib_method: 'Tipo de Atribuição a Revisores' ,
            rev_fin_dec_date : 'Data da decisão final do revisor' ,
            rev_resp_date :      'Data de resposta de revisão' ,
            save:               'Guardar',
            scientific_difusion:               'Difusão',
            search:             'Pesquisar',
            see_details:        'Ver detalhes',
            see_selected_articles : 'Ver artigos seleccionados' ,
            select_articles :  'Selecionar artigos' ,
            select_call_for_paper :  'Selecione a call for paper' ,
            select_magazine_conference :  'Selecione a revista/conferência' ,
            select_state_placholder :  'Selecione o estado' ,
            select_your_files :  'Clique aqui para seleccionar os seus ficheiros' ,
            selected_item:      'item seleccionado.',
            selected_items:     'items selecionados.',
            session:            'Sessão',
            sessions:            'Sessões',
            sessions_number:    'Nº de Sessões',
            spanish:            'Espanhol' ,
            sscholarid:         'Semantic Scholar ID',
            start_date :        'Data de início' ,
            status:             'Estado',
            submitted:          'Submetido',
            submitted_application: 'Pedido enviado',
            submission_data:    'Dados de submissão' ,
            submission_date:    'Data de submissão' ,
            submission_rules:   'Normas de submissão',
            submission_rules_pdf:'Ver normas de submissão',
            sup_mat_deliv_date : 'Data de entrega de material suplementar' ,
            surname:            'Apelido',
            surname_insert:     'Introduza o apelido',
            template :          'Modelo' ,
            total_cfp:          'Total de call for papers',
            table_all:          'Todos',
            table_date:         'Data',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_state:        'Estado',
            table_title:        'Título',
            target_audience:    'Destinatários/condições de inscrição',
            text:               'Texto',
            title:              'Título',
            title_secondary :   'Título Secundário',
            title_placeholder:  'Introduza o título',
            topic :             'Tópico' ,
            topics :            'Tópicos' ,
            type:               'Tipo',
            type_placeholder:   'Introduza o tipo',
            under_review:       'Em revisão',
            unpublished:        'Não publicado',
            unrestricted :      'Sem Restrição' ,
            upload_file_error : 'Apenas são permitidos ficheiros pdf, doc e docx.\nTamanho máximo: 10MB.\n\n' ,
            upload_file_types_1:      'Adicionar ficheiro pdf, doc ou docx. Tamanho máximo: 10MB.',
            upload_image_error : 'Apenas são permitidos ficheiros pdf, jpg e png.\nTamanho máximo: 10MB.\n\n' ,
            user:               'Utilizador',
            username:           'Utilizador', 
            username_error_message:  'Já existe um registo com este username.',
            username_insert:    'Introduza o utilizador',
            usertype:           'Tipo de utilizador',
            view:               'Ver',
            warning:            'Aviso' ,
            warning_cfp:        'A Call For Papers tem registos associados. Apenas pode ser editada.',
            web_page:           'Página Web',
            welcome:            'Bem-vindo(a)',
            yes :               'Sim' ,
            unread_messages:    'Nova mensagem',
            
               
            
            /* FRONT */
            agree_terms_conditions: 'Concordo com os ', 
            cfp_status_closed:  'fechado',
            cfp_status_ending:  'a terminar',
            cfp_status_open:    'aberto',
            cfp_status_soon:    'brevemente',  
            content_edit:       'Editar conteúdo',
            content_new:        'Novo conteúdo',
            content_list:       'Lista de conteúdos',
            dates:              'Datas',
            date_creation:      'Criação',
            date_publication:   'Publicação',
            date_last_update:   'Última actualização',
            developed:          'Desenvolvido por',
            discover:           'Descobrir',
            edit_title:         'Editar Registo',

            
            edit_success:       'Registo actualizado com sucesso!',
            email_placeholder:  'Introduza o email',
            end:                'Fim',
            enter_country_residence:  'Introduza o país de residência',
            file_attach:        'Attach file',
            file_remove_all:    'Remove all',
            file_upload:        'Upload file',
            file_upload_all:    'Upload all',
            filter_placeholder: 'Procurar',
            form_autor_register: 'Formulário de registo de autor',
            
            insert_success:     'Registo inserido com sucesso!',
            learn_more:         'Saber mais',
            location:           'Localização',
            login:              'Iniciar sessão',
            logout:             'Sair',

            multimedia:         'Multimédia',
            
            message:            'Mensagem',
            message_placeholder:    'Introduza a mensagem',
            organization:       'Organização',
            page_config:        'Configuração da Página',
            page_parent:        'Parent',
            pages:              'Páginas',
            principal:          'Principal',
            privacy_policy:     'Política de privacidade',
            read_terms_conditions: 'Leia os nossos termos e condições antes de submeter o formulário.', 
            regist:             'Registo',
            register:             'Registe-se',
            reserved_rights:    'Todos os direitos reservados',
            scientia_magazine:  'Revista Científica',
            search_by_article_name:             'Pesquisa por nome de artigo', 
            search_by_author_name:             'Pesquisa por nome de autor', 
            search_by_article_keyword:             'Pesquisa por keywords', 
            send:               'Enviar',   
            send_title:         'Enviar mensagem',
            seo_config:         'Configuração SEO',
            seo_description:    'Descrição SEO',
            seo_description_placeholder: 'Introduza a descrição SEO',
            seo_keywords:       'Keywords SEO',
            seo_keywords_small: '(separar por virgula)',
            seo_keywords_placeholder: 'Introduza as keywords SEO',
            seo_title:          'Título SEO',
            seo_title_placeholder: 'Introduza o título SEO',
            start:              'Início',
            submission:         'Submissão',
            submit:     'Submeter',
            
            submit_article:     'Submeter artigo',
            table_parent:       'Parent',
            table_actions:      'Acções',
            technical_team:     'Corpo técnico',
            terms_conditions:   'Termos e condições',          
            terms_conditions_link:   'termos e condições.',
            terms_conditions_required: 'Os campos assinalados com (*) são de preenchimento obrigatório. O endereço de email permite um contacto mais rápido em caso de necessidade de esclarecimentos adicionais. A informação que submeter não será usada ou distribuída por outra razão que não o processamento do seu pedido.',

            
            dash_testimony:   'Testemunhos',
            dash_inscricoes:  'Inscrições em formações',
            dash_atribuido:   'Atribuido a formações',
            dash_cursos:      'Total de cursos',
            dash_cursos_desenvolvimento:      'Cursos a decorrer/a iniciar',
            dash_cursos_terminados:      'Cursos concluídos',
            dash_formandos_registados:   'Formandos registados',
            dash_formadores_registados:   'Formadores registados',
            dash_noticias:    'Notícias',

            calendar_daynames:  ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        },
    'en':
        {
            abstract: 'Abstract',
            accepted_languages : 'Accepted languages?' ,
            accepted:    'Accepted',
            accepted_change:    'Accepted subject to change',
            access_data:        'Access data',
            add :       'Add',
            add_author:       'Add author' ,
            add_cfp :       'Add CFP' ,
            add_files:      'Add files',
            add_files_placeholder : 'Click here to add files' ,
            add_guest:      'Add guest' ,
            add_new :       'Add new' ,
            add_new_appreciation:   'Add new appreciation',
            add_new_appreciation_info_message:   'For your appreciation to be saved, click on the "submit" button and then "save".',
            add_new_cfp :       'Add new Call for papers' ,
            add_new_cfp_article_edit_deadline: 'Article edit deadline' ,
            add_new_cfp_article_edit_deadline_placeholder: 'Insert the article edit deadline' ,
            add_new_cfp_description_placeholder: 'Insert the description for the CFP' ,
            add_new_cfp_end_date: 'End date' ,
            add_new_cfp_end_date_placeholder : 'Insert the end date' ,
            add_new_cfp_name_placeholder: 'Insert the name of the CFP' ,
            add_new_cfp_process_end_date : 'Process end date' ,
            add_new_cfp_process_end_date_placeholder : 'Insert the process end date' ,
            add_new_cfp_rev_fin_dec_date : 'Date of the reviewer\'s final decision' ,
            add_new_cfp_rev_fin_dec_date_placeholder : 'Insert the date of the reviewer\'s final decision' ,
            add_new_cfp_rev_resp_date : 'Review response date' ,
            add_new_cfp_rev_resp_date_placeholder : 'Insert the review response date' ,
            add_new_cfp_start_date: 'Start date' ,
            add_new_cfp_start_date_placeholder : 'Insert the start date' ,
            add_new_cfp_submission_date: 'Submission date' ,
            add_new_cfp_submission_date_placeholder : 'Insert the submission date' ,
            add_new_cfp_sup_mat_deliv_date : 'Supplementary material delivery date' ,
            add_new_cfp_sup_mat_deliv_date_placeholder : 'Insert the supplementary material delivery date' ,
            add_new_cfp_text :  'To save the Call for papers click the "Add Cfp" button and then click "save".' ,
            add_new_sientific_diffusion_text :  'Choose the call for paper and then select the articles from it to add to the dissemination.' ,
            add_publisher : 'Add publisher' ,
            add_question : 'Add question' ,
            add_reviewer:       'Add reviewer',
            add_select_articles :  'Add selected article(s)',
            add_select_articles_error_message :  'No article(s) selected.' ,
            add_select_articles_sucess_message :  'Article(s) successfully added.' ,
            add_topic : 'Add Topic' ,
            admin:              'Admin',
            adress:             'Address', 
            affiliation:        'Affiliation',
            affiliation_insert: 'Insert the affiliation',
            appreciations:      'Appreciations',
            article:            'Article',
            article_appreciation:   'Article appreciation',
            article_appreciation_view:   'Consult article appreciation',
            article_final_appreciation: 'Final appreciation of the article',
            article_code:       'Article code',
            article_edit_deadline: 'Article edit deadline' ,
            article_status:      'Article status',
            article_final_status:   'Article final status',
            article_submission: 'Article submission',
            article_submission_limit_message_1: 'You can only submit',
            article_submission_limit_message_2: 'article(s) for this Call For Papper.',
            article_submission_email_message_1: 'This email is used to notify you that the author ',
            article_submission_email_message_2: ' submitted the article ',
            article_submission_email_message_3: ' on the following date: ',
            article_submission_email_message_4: ' by ',
            article_resubmission_email_message_1: 'This email is used to notify you that, following the respective appraisal, the author ',
            article_resubmission_email_message_2: ' resubmitted the article ',
            article_resubmission_email_message_3: ' on the following date: ',
            article_resubmission_email_message_4: ' by ',
            article_title:      'Article title',
            article_review:     'Articles review',
            articles:           'Articles',
            articles_approved:      'Total approved articles',
            articles_assigned:      'Total assigned articles',
            articles_for_review:      'Total articles for review',
            articles_list:      'Articles list',
            articles_list_view:      'View articles list',
            articles_publication_error_message:      'Problem updating article data!',
            articles_publication_sucess_message :    'Articles associated with the magazine successfully updated' ,
            articles_reviewed:      'Total reviewed articles',
            articles_submission:'Article Submission',
            articles_submitted: 'Total submitted articles',
            assign_reviewer:    'Assign reviewer',
            assign_reviewer_confirm_message:    'Are you sure you want to save this reviewer and send the corresponding notification?',
            assign_reviewers:    'Assign reviewers',
            assign_reviewers_confirm_message:    'Are you sure you want to save this reviewers and send the corresponding notifications?',
            author:             'Author',
            author_regist:      'Author regist', 
            authors:            'Authors',
            authors_list:       'Authors list',
            author_question_authorization:    'Are the authors allowed to see the questions and answers?',
            automatic_method :	'Automatic' ,
            available_vacancies:    'Nº de vagas disponíveis',
            back:               'Go back',
            bibliography:       'Bibliography',
            biography:          'Biography',
            cancel:             'Cancel',
            can_submit_article :    'Can submit article?' ,
            certificate:        'Certificate',
            certificate_view:   'View certificado',
            cfp_delete_confirm_message:      'Are you sure you want to delete this dissemination?',
            cfp_description:    'Call for Papers description' ,
            cfp_list : 'Call For Papers List' ,
            cfp_name :          'Name of the Call for Papers' ,
            change_password:    'Change password',
            change_password_confirm_message:    'Are you sure you want to change your password?',
            change_password_error_message:    'Problem updating password!',
            change_password_required_fields_message:    'You have to fill in all the fields related to the password change',
            change_password_sucess_message:    'Password updated successfully',
            choose_file:        'Choose file',
            close:              'Close',
            code:               'Code',
            confirmation_password_error_message:               'Confirmation password different from the password entered',
            conference :        'Conference' ,
            contacts:           'Contacts', 
            contact_email:      'Contact Email', 
            contact_recovery:   'Recovery form',  
            content:            'Contents',  // TODO: content means happy :)
            contents_plural:    'Contents',
            contents_plural_list:    'Contents list',
            content_insert:       'Insert content',
            country:            'Country',
            country_insert:     'Insert the country',
            courses_available:          'Available courses',
            courses_detail:          'Detalhes do curso',
            courses_list:          'Courses list',
            current_password:   'Current password',
            current_password_error_message:   'Current password is incorrect',
            date_registration_begin:  'Data de início de inscrição',
            date_registration_deadline:  'Data limite de inscrição',
            dashboard:          'Dashboard' ,
            data_article:       'Data article',
            date_placeholder:      'Insert date',
            delete:             'Delete',
            delete_article_confirm_message:     'Are you sure you want to delete this article?',
            delete_cfp:         'Delete Call For Papers',
            delete_cfp_cancel:  'No' ,
            delete_cfp_confirm: 'Yes' ,
            delete_cfp_text:    'Are you sure you want to delete this register?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_entity :     'Delete Entity' ,
            delete_entity_text : 'Are you sure you want to delete this Entity?' ,
            delete_error:       'Problem deleting the element!',
            delete_event :      'Are you sure you want to delete this Event?' ,
            delete_image:       'Delete image',
            delete_image_confirm_message:     'Are you sure you want to delete this image?',
            delete_image_error_message:     'There is no image',
            delete_profile_image:       'Delete profile image',
            delete_profile_image_confirm_message:     'Are you sure you want to delete this profile image?',
            delete_profile_image_error_message:     'There is no profile image',
            delete_record :     'Are you sure you want to delete this record?',
            delete_success:     'Element deleted successfully!',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            dblpid:             'DBLP ID',
            description:        'Description',
            description_placeholder:      'Insert description',
            doc_choose:         'Choose file',
            duplicate_title:       'Duplicate Regist',
            duplicate_text:        'Are you sure you want to continue?',
            duplicate_confirm:     'Confirm',
            duplicate_cancel:      'Cancel',
            duplicate_error:       'Problem duplicating element!',
            duplicate_no:       'No',
            duplicate_yes:      'Yes',
            duplicated:         'duplicated',
            duplication_options: 'duplication options',
            duplication_options_checkbox_01: 'Keep image',
            duplication_options_checkbox_02: 'Keep documents',
            duplication_options_checkbox_03: 'Keep trainers',
            duration:           'Duração (nº de horas)',
            edit:               'Edit',
            edit_cancel:        'No',
            edit_confirm:       'Yes',
            edit_error:         'Problem updating element!',
            edit_text:          'Are you sure you want to continue?',
            edition:            'Edition',
            edition_placeholder:      'Insert edition',
            editor_regist:      'Editor regist',
            email:              'E-mail',
            email_contact:      'Contact e-mail',   
            email_recover_pass: 'Check your email.',
            email_recover_pass_2: 'E-mail is not registered.',
            email_register:     'Register',
            email_settings:     'E-mail settings',
            end_date:           'End date' ,
            english :           'English' ,
            error:              'Error',
            event :             'Event' ,
            event_type:         'Event type',
            events_data:        'Events data' ,
            events:             'Events',
            events_list:        'Events list',
            failed_login:       'Failed login',
            financing:          'Financiamento/custo',
            financing_financed: 'Financiada',
            financing_free:      'Gratuita',
            financing_paid:      'Paga',
            file_types :        'File types?' ,
            files:              'File(s)',
            formation_language:  'Lingua da formação',
            formation_language_pt:  'Português',
            formation_language_en:  'Inglês',
            formation_language_es:  'Espanhol',
            formation_modality:  'Tipo de Modalidade',
            formation_modality_classroom:  'Presencial',
            formation_modality_online:  'À Distância (online)',
            formation_modality_mixed:  'Misto',
            formation_price:    'Price',
            formation_registered: 'Registered',
            formation_waiting_registered: 'A aguardar aprovação',
            formation_registration: 'Registration',
            formation_registration_finish: 'Finish registration',
            formation_registration_finish_error: 'Problem finishing registration request',
            formation_registration_finish_text: 'Vai finalizar o pedido de inscrição no curso ',
            formation_registration_confirm: 'Tem a certeza que pretende inscrever-se neste curso?',
            formation_registration_success: 'Pedido de inscrição efetuado com sucesso.</br> O seu pedido vai ser analisado e será informado(a) da sua resposta brevemente.',
            formation_registration_profile:        'Ir para o perfil',
            formation_registration_rejected: 'Registration rejected',
            formation_registration_waiting: 'Waiting for response',
            formation_registration_warning:        'É necessário o preenchimento de todos os campos obrigatórios do seu perfil para que a inscrição neste curso seja concluída com sucesso!',
            formation_schedule:  'Tipo de Horário',
            formation_schedule_working_hours: 'Laboral',
            formation_schedule_post_work: 'Pós Laboral',
            formation_schedule_flexible: 'Flexivel',
            french :            'French' ,
            gest:               'Gest',
            gscholarid:         'Google Scholar ID',
            guests :            'Guests' ,
            guest_affiliation : 'Guest\'s affiliation',
            guest_affiliation_placeholder : 'Insert the guest\'s affiliation' ,
            guest_area :        'Guest\'s Area ' ,
            guest_area_placeholder :        'Insert the guest\'s area' ,
            guest_description : 'Guest\'s description' ,
            guest_description_placeholder : 'Insert the guest\'s description' ,
            guest_name :        'Guest\'s name' ,
            guest_name_placeholder :        'Insert the guest\'s name' ,
            hello:               'Hello',
            home:               'Home',
            hours:              'Hour(s)',
            id:                 'ID',
            identifier:         'Enter identifier',
            image:              'Image',
            image_choose:       'Choose imagem',
            in_progress:        'In progress',
            incorrect_login_data: 'Incorrect login data',
            incorrect_request:  'Incorrect request',
            insert_cancel:      'No',
            insert_cfp_reqs:    'Must fill in the title and description fields of the CFP.',
            insert_confirm:     'Yes',
            insert_diffusion:   'Insert Dissemination',
            insert_error:       'Problem updating element!',
            insert_event :      'Insert event' ,
            insert_event_cfp_error_message :      'You have not submited any Call for Paper associated with this Event.' ,
            insert_option:      'Insert option' ,
            insert_question :   'Insert the question' ,
            insert_text:        'Are you sure you want to continue?',
            insert_title:       'New Register',
            insert_url:         'Insert the URL',
            journals_list:      'List of journals',
            published_journals: 'Published journals',
            keywords:           'Keywords',
            keywords_info:      'Always use ";" to separate your keywords.',
            keywords_insert:    'Enter your keywords',
            link:               'Link',
            list_view:          'View list',
            loading :           'Loading' ,
            magazine :          'Magazine' ,
            magazine_code :     'Magazine Code' ,
            magazine_conference :  'Magazine/Conference' ,
            manual :            'Manual' ,
            materials:          'Materials',
            max_numb_art_author : 'Maximum number of articles per author?' ,
            max_numb_art_author_placeholder : 'Insert the maximum number of articles per author' ,
            max_numb_art_reviewer : "Maximum number of articles per reviewer?" ,
            max_numb_art_reviewer_placeholder : "Insert the maximum number of articles per reviewer" ,
            max_numb_rev_per_art : 'Maximum number of reviewers per article?' ,
            max_numb_rev_per_art_placeholder : 'Insert the maximum number of reviewers per article' ,
            maximum_submissions_reached: 'maximum submissions reached',
            name:               'Name',
            name_placeholder:   'Insert the name',
            new_password:       'Nova password',
            new_password_2:     'Confirmar password',
            new_question : 'New question' ,
            new_question_placeholder : 'Insert a question' ,
            new_topic :         'New topic' ,
            no :               'No' ,
            no_file_selected:   'Nenhum ficheiro selecionado',
            no_results:         'No results', 
            notice:             'Notice',
            notice_message:             'Passados 15 dias da data de conclusão do curso, o formando deixa de ter acesso à gestão e visualização dos conteúdos desse curso.',
            notifications_error_message:             'Problem sending notifications!',
            notifications_sucess_message:             'Notifications sent successfully',
            notified:           'Notified',
            notify:             'Notify',
            notify_author_button:      'Notify author',
            notify_appreciation:'Notify  appreciation',
            notify_appreciation_error_message: 'You did not select a final state!',
            notify_author:      'This email is to notify you that your article',
            notify_author_2:    'has been assigned the final status',
            notify_all:         'Notify all',  
            notify_message:     'Are you sure you want to give this appreciation and notify the author of the relevant article?',
            objectives:         'Objetivos',
            observations:       'Observations',
            obs_publisher:      'Notes for the publisher',
            orcid:              'ORCID',
            password:           'Password',
            password_recover:   'A request to recover your account password has been registered.',
            password_recover_2: 'Click on the following link to confirm your request and choose another password:',
            password_recover_3: 'If you have not made any request, ignore this e-mail and your password will not be changed.',
            personal_data:      'Personal data',
            portuguese :        'Portuguese' ,
            proceedings_list:   'List of Proceedings',
            process_end_date :  'Process end date' ,
            profile:            'Profile',
            profile_image:      'Profile image',
            publication:        'Publication',
            publication_confirm_message:      'Are you sure you want to publish this magazine?',
            publication_error_message:      'Problem publishing magazine!',
            publication_sucess_message:      'Magazine successfully published',
            publication_date:   'Publication date',
            publish:            'Publish',
            publisher:          'Publisher' ,
            publishers:         'Publishers',
            list_publishers:    'Publishers list',
            published:          'Published',
            published_articles: 'Total of published articles',
            publisher_type:     'Tipo de editor',
            question :          'Question' ,
            questions :         'Questions' ,
            recover_password:   'Recover password',
            register_here:      'Register here',
            rejected:           'Rejected',
            remove:             'Remove',
            remove_all:      'Remove all',
            remove_article :    'Remove article' ,
            remove_appreciation :    'Remove appreciation' ,
            remove_author :     'Remover author' ,
            remove_cfp:         'This Call for Paper is ongoing. It can\'t be removed',
            remove_file:      'Remove file',
            remove_publisher :  'Remove publisher' ,
            review_type :       'Review type?' ,
            reviewer:           'Reviewer',
            reviewer_assignment: 'Reviewer assignment',
            reviewer_assignment_email_message_1: 'This email is used to notify you that the following article has been assigned to you: ',
            reviewer_assignment_error_message: 'Did not add any reviewers!',
            reviewer_regist:    'Reviewer regist',
            reviewer_attrib_method: 'Reviewers attribution method' , // Tipo de Atribuição a Revisores
            reviewers:          'Reviewers',
            reviewers_list:     'Reviewers list',
            registered_authors: 'Registered authors',
            registered_reviewers: 'Registered reviewers',
            rev_fin_dec_date :  'Date of the reviewer\'s final decision' ,
            rev_resp_date :     'Review response date' ,
            save:               'Save',
            scientific_difusion:               'Dissemination',
            search:             'Search',
            see_details:        'See details',
            see_selected_articles : 'See select  articles' ,
            select_articles :  'Select  articles' ,
            select_call_for_paper :  'Select call for paper' ,
            select_magazine_conference :  'Select magazine/conference' ,
            select_state_placholder :  'Select state' ,
            select_your_files :  'Click here to select your files' ,
            selected_item:      'selected item.',
            selected_items:      'selected items.',
            send:               'Send',
            send_title:         'Send message',
            session:            'Session',
            sessions:           'Sessions',
            sessions_number:    'Nº de Sessões',
            spanish:            'Spanish' ,
            sscholarid:         'Semantic Scholar ID',
            start_date :        'Start date' ,
            status:             'Status',
            submitted:          'Submitted',
            submitted_application: 'Submitted application',
            submission_data:    'Submission data' ,
            submission_date:    'Submission date' ,
            submission_rules:   'Submission rules',
            submission_rules_pdf:'Open submission rules',
            sup_mat_deliv_date : 'Supplementary material delivery date' ,
            surname:            'Surname',
            template :          'Template' ,
            surname_insert:     'Insert the surname',
            total_cfp:          'Total call for papers',
            table_all:          'All',
            table_date:         'Date',
            table_rows_per_page:'Records per page:',
            table_separator:    'of',
            table_title:        'Title',
            target_audience:    'Destinatários/condições de inscrição',
            text:               'Text',
            title:              'Title',
            title_placeholder:  'Insert title',
            title_secondary :   'Secondary title' ,
            title_secondary_placeholder : 'Insert title' ,
            topic :            'Topic' ,
            topics :            'Topics' ,
            type:               'Type',
            type_placeholder:   'Insert type',
            under_review:       'Under review',
            unpublished:        'Unpublished',
            unrestricted :      'Unrestricted' ,
            upload_file_error : 'Only pdf, doc and docx files are allowed.\nMaximum size: 10MB.\n\n' ,
            upload_file_types_1:      'Add pdf, doc or docx file. Maximum size: 10MB.',
            upload_image_error : 'Only pdf, jpg and png files are allowed.\nMaximum size: 10MB.\n\n',
            user:               'User',
            username:           'Username', 
            username_error_message:  'There is already a record with this username.',
            username_insert:    'Insert the username',
            usertype:           'User Type',
            view:               'View',
            warning:            'Warning' ,
            warning_cfp:        'The Call For Papers has associated registers. It can only be edited.' ,
            web_page:           'Web Page',
            welcome:            'Welcome',
            yes :               'Yes' ,
            unread_messages:    'Nova mensagem',





            /* FRONT */
            agree_terms_conditions:   'I agree to ',
            cfp_status_closed:  'closed',
            cfp_status_ending:  'ending',
            cfp_status_open:    'open',
            cfp_status_soon:    'soon',
            content_edit:       'Edit content',
            content_new:        'New content',
            content_list:       'Content list',
            dates:              'Dates',
            date_creation:      'Creation',
            date_publication:   'Publication',
            date_last_update:   'Last update',

            developed:          'Developed by',
            discover:           'Discover',
            edit_title:         'Edit Regist',
            edit_success:       'Successful updated element!',
            email_placeholder:  'Insert the email',
            end:                'End',
            enter_country_residence:  'Enter country of residence',
            file_attach:        'Attach file',
            file_remove_all:    'Remove all',
            file_upload:        'Upload file',
            file_upload_all:    'Upload all',
            filter_placeholder: 'Search',
            form_autor_register: 'Author registration form',
            insert_success:     'Successful updated element!',
            learn_more:         'Learn more',
            location:           'Location',
            login:              'Login',
            logout:             'Logout',
            message:            'Message',
            message_placeholder:'Insert the message',
            multimedia:         'Multimedia',
            organization:       'Organization',
            page_config:        'Page config',
            page_parent:        'Parent',
            pages:              'Pages',
            principal:          'Principal',
            privacy_policy:     'Privacy Policy',
            read_terms_conditions: 'Please read our terms and conditions before submitting the form.', 
            regist:             'Register',
            register:             'Register',
            reserved_rights:    'All rights reserved',
            scientia_magazine:  'Scientia Magazine',
            search_by_article_name:             'Search by article name', 
            search_by_author_name:             'Search by author name', 
            search_by_article_keyword:             'Search by keywords', 
            seo_config:         'SEO config',
            seo_description:    'SEO description',
            seo_description_placeholder: 'Insert the SEO description',
            seo_keywords:       'SEO keywords',
            seo_keywords_small: '(separate by comma)',
            seo_keywords_placeholder: 'Insert the SEO keywords',
            seo_title:          'SEO title',
            seo_title_placeholder: 'Insert the SEO title',
            start:              'Start',
            submission:         'Submission',
            submit:             'Submit',
            submit_article:     'Submit article',
            table_parent:       'Parent',
            table_state:        'State',
            table_actions:      'Actions',

            terms_conditions:   'Terms and conditions',
            terms_conditions_link:   'terms and conditions.',
            terms_conditions_required: 'The fields marked with (*) are required. The email address allows for faster contact in the event of further clarification. The information you submit will not be used or distributed for any other reason other than the processing of your request.',
            technical_team:     'Technical team',

            dash_testimony:   'Testimonials',
            dash_inscricoes:  'Inscrições em formações',
            dash_atribuido:   'Atribuido a formações',
            dash_cursos:      'Total de cursos',
            dash_cursos_desenvolvimento:      'Cursos a decorrer/a iniciar',
            dash_cursos_terminados:      'Cursos terminados',
            dash_formandos_registados:   'Formandos registados',
            dash_formadores_registados:   'Formadores registados',
            dash_noticias:    'News',

            calendar_daynames:  ['Sun', 'Mon', 'Thu', 'Wed', 'Thr', 'Fri', 'Sat'],
        }
}

module.exports = {
    language
};